import {
  Button,
  Checkbox,
  FormGroup,
  FormHelperText,
  InputLabel,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Select,
  TextField,
} from '@mui/material';
import React, { useEffect } from 'react';
import { Controller } from 'react-hook-form';

function CreateSingleAlertModal({
  handleSubmit,
  handleAddAlert,
  register,
  errors,
  editData,
  validationErrors,
  handleActiveChange,
  handleremoveError,
  fields,
  control,
  statusOptions,
  remove,
  editIndex,
  setEditIndex,
  append,
  reset,
  navigate,
  isActive,
  toggleDrawer,
}: any) {

    useEffect(() => {
  if (editData) {
    reset({
      eventType: editData.eventType,
      values: editData.values,
    });

    // run validation/activation immediately
    handleActiveChange();
  }
}, [editData, reset]);

  return (
    <>
      <>
        <form
          onSubmit={handleSubmit((data: any) => {
            handleAddAlert(data);
            toggleDrawer(false); // close drawer after submit
          })}
        >
          <div className="controller_form_container">
            <div className="create_controller-nodata_drawer">
              <div className="create_controller-nodata_drawer_heading_content">
                <h2 className="create_controller-nodata_drawer_heading">
                  {editIndex !== null ? 'Edit Event' : 'Add Event'}
                </h2>
              </div>

              <div className="create_controller-nodata_drawer_form_content">
                  <FormGroup className="create_controller-nodata_drawer_form_field">
              <InputLabel className="create_controller-nodata_drawer_form_field_lable">
Event Type
              </InputLabel>
                <TextField
                  className="create_controller-nodata_drawer_form_field_input"
                          id="eventType"
                          variant="outlined"
                          fullWidth
                          {...register('eventType', {
                            required: 'Event Type is required',
                            pattern: {
                              value: /^[a-zA-Z0-9_-]+$/, // only letters, numbers, dash, underscore
                              message:
                                'Only letters, numbers, dashes, and underscores are allowed',
                            },
                          })}
                          error={!!errors.eventType}
                          helperText={errors.eventType?.message}
                        //   disabled={editData ? true : false}
                          onChange={() => {
                            handleActiveChange();
                            handleremoveError('eventType');
                          }}
                        />
                          {validationErrors.eventType && (
                      <span className="text-danger">
                        {validationErrors.eventType}
                      </span>
                    )}
              </FormGroup>
              

                <div
                  style={{
                  
                 
                  }}
                >
                  {fields.map((item: any, index: any) => (
                    <div
                      key={item.id}
                      className="create_controller_form"
                      style={{}}
                    >
                      {/* Value */}
                        <FormGroup className="create_controller-nodata_drawer_form_field">
                             <InputLabel className="create_controller-nodata_drawer_form_field_lable">
                                            Value
                                          </InputLabel>
  <TextField
  className="create_controller-nodata_drawer_form_field_input"
                              fullWidth
                              {...register(`values.${index}.value`, {
                                required: 'Value is required',
                              })}
                              error={!!errors.values?.[index]?.value}
                              helperText={
                                errors.values?.[index]?.value?.message
                              }
                            />
                        </FormGroup>
                 

                      {/* Title */}
                        <FormGroup className="create_controller-nodata_drawer_form_field">
                               <InputLabel className="create_controller-nodata_drawer_form_field_lable">
                                            Title
                                          </InputLabel>
                                            <TextField
                                            className="create_controller-nodata_drawer_form_field_input"
                              fullWidth
                              {...register(`values.${index}.title`, {
                                required: 'Title is required',
                              })}
                              error={!!errors.values?.[index]?.title}
                              helperText={
                                errors.values?.[index]?.title?.message
                              }
                            />
                        </FormGroup>
                      

                      {/* Description */}
                        <FormGroup className="create_controller-nodata_drawer_form_field">
                              <InputLabel className="create_controller-nodata_drawer_form_field_lable">
                              Description
                              </InputLabel>
  <TextField
   className="create_controller-nodata_drawer_form_field_textarea"

                              fullWidth
                                style={{borderRadius:"8px"}}
                              multiline
                              minRows={3}
                              {...register(`values.${index}.desc`, {
                                required: 'Description is required',
                              })}
                              error={!!errors.values?.[index]?.desc}
                              helperText={errors.values?.[index]?.desc?.message}
                            />
                        </FormGroup>
                   

                      {/* Icon */}
                         <FormGroup className="create_controller-nodata_drawer_form_field">
                              <InputLabel className="create_controller-nodata_drawer_form_field_lable">
                               Icon
                              </InputLabel>
                                <Controller
                                
                              name={`values.${index}.icon`}
                              control={control}
                              rules={{ required: 'Icon is required' }}
                              render={({ field }) => (
                                <Select
                                     className="create_controller-nodata_drawer_form_field_input"
                                  {...field}
                                  fullWidth
                                  displayEmpty
                                  renderValue={(selected) => {
                                    if (!selected) return 'Select Icon';
                                    const option = statusOptions.find(
                                      (opt: any) => opt.value === selected,
                                    );
                                    return (
                                      <div className="flex items-center gap-2">
                                        {option?.icon}
                                        {option?.label}
                                      </div>
                                    );
                                  }}
                                >
                                  {statusOptions.map((option: any) => (
                                    <MenuItem
                                      key={option.value}
                                      value={option.value}
                                    >
                                      <ListItemIcon>{option.icon}</ListItemIcon>
                                      <ListItemText primary={option.label} />
                                    </MenuItem>
                                  ))}
                                </Select>
                              )}
                            />
                              {errors.values?.[index]?.icon && (
                            <FormHelperText className="text-danger">
                              {errors.values[index].icon.message}
                            </FormHelperText>
                          )}
                         </FormGroup>
                    

                      {/* Channels */}
    <FormGroup className="create_controller-nodata_drawer_form_field">
          <InputLabel className="create_controller-nodata_drawer_form_field_lable">
          Notification Channels
          </InputLabel>
 <Controller
                              rules={{
                                required: 'At least one channel is required',
                              }}
                              name={`values.${index}.channels`}
                              control={control}
                              render={({ field }) => {
                                const channelOptions = [
                                  { value: 'db', label: 'Store in Log' },
                                  {
                                    value: 'push',
                                    label: 'Push Notifications',
                                  },
                                  { value: 'email', label: 'Send an Email' },
                                ];

                                return (
                                  <Select
                                       className="create_controller-nodata_drawer_form_field_input"
                                    {...field}
                                    multiple
                                    fullWidth
                                    displayEmpty
                                    value={field.value || []}
                                    onChange={(e) =>
                                      field.onChange(e.target.value)
                                    }
                                    renderValue={(selected) =>
                                      selected.length === 0
                                        ? 'Select Notifications'
                                        : channelOptions
                                            .filter((opt) =>
                                              selected.includes(opt.value),
                                            )
                                            .map((opt) => opt.label)
                                            .join(', ')
                                    }
                                  >
                                    {channelOptions.map((option) => (
                                      <MenuItem
                                        key={option.value}
                                        value={option.value}
                                      >
                                        <Checkbox
                                          checked={field.value?.includes(
                                            option.value,
                                          )}
                                        />
                                        <ListItemText primary={option.label} />
                                      </MenuItem>
                                    ))}
                                  </Select>
                                );
                              }}
                            />
                               {errors.values?.[index]?.channels && (
                            <FormHelperText className="text-danger">
                              {errors.values[index].channels.message}
                            </FormHelperText>
                          )}
    </FormGroup>

                    

                      {/* Remove Button */}

        <div className="create_controller-nodata_drawer_button">
                        <Button
                        color='error'
                          variant="contained"
                            sx={{textTransform:"none",boxShadow:"none"}}
                          className={
                            fields.length === 1
                              ? 'save_button disabled_button'
                              : 'save_button'
                          }
                          disabled={fields.length === 1} // ✅ disables if only 1 value left
                          onClick={() => remove(index)}
                        >
                          Remove
                        </Button>
                      </div>

                  
                    </div>
                  ))}

                  <div
                    className="create_controller_form-submit"
                    style={{
                      display: 'flex',
                      justifyContent: 'flex-start',
         
                    }}
                  >
                    <Button
                      className="save_button"
                     
                          variant="contained"
                            sx={{textTransform:"none",boxShadow:"none"}}
                
                
                      onClick={() =>
                        append({
                          value: '',
                          title: '',
                          desc: '',
                          icon: '',
                          channels: [],
                        })
                      }
                    >
                      + Add Another Value
                    </Button>
                  </div>
                </div>
              </div>
            </div>
         

          <div className="create_controller-nodata_drawer_button_content">
            <div className="create_controller-nodata_drawer_button">
              <Button
               variant="text"
              className="cencel_button"
                onClick={() => toggleDrawer(false)}
              >
                Cancel
              </Button>

              <Button
               variant="contained"
              
                disabled={
                  Object.keys(validationErrors).length > 0 ||
                  (validationErrors.values?.some(
                    (v: any) => Object.keys(v).length > 0,
                  ) ??
                    false) ||
                  !isActive
                }
                type="submit"
                className={
                  !isActive || Object.keys(validationErrors).length > 0 ||(validationErrors.values?.some(
                    (v: any) => Object.keys(v).length > 0,
                  ) ??
                    false) 
                    ? 'save_button disabled_button'
                    : 'save_button'
                }
              >
                {editIndex !== null ? 'Save Changes' : 'Add Event'}
              </Button>
            </div>
          </div>
           </div>
        </form>
      </>
    </>
  );
}

export default CreateSingleAlertModal;
